// ============================================================
// TMR Portal Admin — the Empresa's segment: the V2's own catalogue and its PT-BR labels (32 §9)
// ============================================================
import type { CompanySegment } from './contract';

/**
 * Every segment an Empresa can be given, in the order the select offers them.
 *
 * A constant and not a request, unlike the classification: the catalogue is the V2's own and fixed in the
 * backend's code (32 §5), so there is nothing to fetch — only the labels, which are copy and live here.
 */
export const COMPANY_SEGMENTS: readonly { value: CompanySegment; label: string }[] = [
  { value: 'Medical', label: 'Médico' },
  { value: 'Dentistry', label: 'Odontologia' },
  { value: 'Veterinary', label: 'Veterinária' },
  { value: 'Aesthetics', label: 'Estética' },
  { value: 'MentalHealth', label: 'Saúde Mental' },
];

/**
 * A segment as the operator reads it. A key the backend added before this screen learned it keeps its own
 * name rather than disappearing.
 *
 * @param segment The catalogue key.
 */
export function segmentLabel(segment: string): string {
  return COMPANY_SEGMENTS.find((s) => s.value === segment)?.label ?? segment;
}

/**
 * The segment a site application's specialty points at, for the wizard to open with (32 §9) — or null when
 * the two catalogues do not line up one to one.
 *
 * Only the specialties whose name *is* a segment are carried over. "Medicina Estética e Integrativa" could be
 * either Médico or Estética, and "Outra" is neither: those open empty, for the team to choose.
 *
 * @param specialty The application's specialty key (28 §5).
 */
export function segmentFromSpecialty(specialty: string): CompanySegment | null {
  return SEGMENT_BY_SPECIALTY[specialty] ?? null;
}

const SEGMENT_BY_SPECIALTY: Record<string, CompanySegment> = {
  AestheticsAndBeauty: 'Aesthetics',
  Dentistry: 'Dentistry',
  MentalHealth: 'MentalHealth',
  Veterinary: 'Veterinary',
};
